/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type MintUserSessionRequestBody = {
  /**
   * Bind the JWT to this MCP server's user_session_issuer audience (any issuer-gated backend, hosted servers included). Mutually exclusive with the other targets; exactly one must be set. Must be issuer-gated and live in the caller's project.
   */
  mcpServerId?: string | undefined;
  /**
   * Bind the JWT to this meta MCP server's user_session_issuer audience. Mutually exclusive with the other targets; exactly one must be set. Must be issuer-gated and live in the caller's project.
   */
  metaMcpServerId?: string | undefined;
  /**
   * Bind the JWT to this toolset's audience. When the toolset has an mcp_servers wrapper the mint resolves to that server (identical to passing its mcp_server_id); otherwise the JWT is bound to the legacy toolset audience. Mutually exclusive with the other targets; exactly one must be set. Must be issuer-gated and live in the caller's project.
   */
  toolsetId?: string | undefined;
};

/** @internal */
export type MintUserSessionRequestBody$Outbound = {
  mcp_server_id?: string | undefined;
  meta_mcp_server_id?: string | undefined;
  toolset_id?: string | undefined;
};

/** @internal */
export const MintUserSessionRequestBody$outboundSchema: z.ZodMiniType<
  MintUserSessionRequestBody$Outbound,
  MintUserSessionRequestBody
> = z.pipe(
  z.object({
    mcpServerId: z.optional(z.string()),
    metaMcpServerId: z.optional(z.string()),
    toolsetId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      mcpServerId: "mcp_server_id",
      metaMcpServerId: "meta_mcp_server_id",
      toolsetId: "toolset_id",
    });
  }),
);

export function mintUserSessionRequestBodyToJSON(
  mintUserSessionRequestBody: MintUserSessionRequestBody,
): string {
  return JSON.stringify(
    MintUserSessionRequestBody$outboundSchema.parse(mintUserSessionRequestBody),
  );
}
